import { VersionSelectorState } from './reducer'
import { ValueProps as VersionSelectorProps } from '@mulesoft/monitoring-center-components/lib/components/Selector/VersionSelector/VersionSelector'

export const VERSION_RESOURCE_NAME = 'version'
export const VERSION_PREFIX = 'MONITORING'

export type VersionSelectorProps = VersionSelectorProps

export const transformToVersionSelectorProps =
  (versionSelector: VersionSelectorState, maxLength: number, testId?: string, disabled?: boolean): VersionSelectorProps => {
    return {
      versions: versionSelector.resources,
      isLoading: versionSelector.isFetching,
      selected: versionSelector.selected,
      maxLength: maxLength,
      disabled: disabled,
      testId: testId,
      title: 'Version / Instance'
    }
  }
